<script>
    import OpeningTimes from './OpeningTimes.vue';

    export default {
        props: {
            user: {
                required: true
            }
        },

        mounted() {
            this.$event_bus.$on('showOpeningTimesModal', (calendar, year, week) => {
                $('#opening-times').modal('show');
                this.$event_bus.$emit('loadOpeningTimes', (calendar, year, week));
            });
        },

        components: {
            OpeningTimes: OpeningTimes,
        }
    }
</script>

<template>
    <div>
        <div id="opening-times" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
            <div class="modal-dialog">
                <div class="panel panel-color panel-inverse m-0">
                    <div class="panel-heading">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="panel-title truncate"><i class="zmdi zmdi-time m-r-10"></i>{{ trans('online_booking.opening_times') }}</h3>
                    </div>
                </div>

                <div class="modal-content p-0">
                    <div class="modal-body p-0" style="min-height: 350px;">
                        <opening-times :user="user"></opening-times>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
